import type { User } from "@supabase/supabase-js";

export function isPlatformAdmin(user: User | null | undefined): boolean {
  const flag = (user?.app_metadata as Record<string, unknown> | undefined)
    ?.platform_admin;
  return flag === true || flag === "true";
}
